// Hocs
import asyncRoute from '../AsyncRoute'

import { MAP_ROUTE_URLS } from '../constants'
import getRequestName from '../components/getRequestName'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-map-dom').HeftyMap
      const requestInfoMaskHoc = require('fc-requests').requestInfoMaskHoc
      const requestInfo$ = require('fc-requests').getFilteredRequestsInProgress$(MAP_ROUTE_URLS)

      resolve(requestInfoMaskHoc({
        requestInfo$,
        getRequestName,
      })(View))

      /* Webpack named bundle   */
    }, 'hefty-map')
  })
}

export default asyncRoute({getComponent, reducers: []})
